/* eslint-disable */
import { ReactElement, useEffect, useState } from "react";

import { ChevronRight, CloseIcon } from "../../common/icons";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { changeLanguage } from "../../store/appSlice";

export type MenuItem = {
  icon?: ReactElement;
  title: string;
  onClick: (item: MenuItem) => void;
  isVisible: boolean;
};

type SideMenuProps = {
  displayMenu: number;
  menuItems: MenuItem[];
};
const SideMenu = ({ displayMenu, menuItems }: SideMenuProps) => {
  const appDispatch = useAppDispatch();
  const [showMenu, setShowMenu] = useState<boolean>(displayMenu > 0);
  const availableLanguages = useAppSelector((state) => state.app.availableLanguages);
  const selectedLanguage = useAppSelector((state) => state.app.appLanguage);

  useEffect(() => {
    setShowMenu(displayMenu > 0);
  }, [displayMenu]);

  const adjustLanguage = (lng: string) => {
    appDispatch(changeLanguage(lng));
    setShowMenu(false);
  };

  return (
    <nav className={`side-menu ${showMenu ? "show" : "hide"}`}>
      <div className="w-full max-w-[800px] h-full flex flex-col gap-4 justify-between">
        <div className="flex justify-end top-0 left-0 right-0">
          <CloseIcon
            className={"w-8 h-8 stroke-side-menu-close-icon"}
            onClick={() => setShowMenu(false)}
          />
        </div>
        <div className="side-menu-items">
          {menuItems
            .filter((x) => x.title && x.isVisible)
            .map((m) => (
              <button
                className="side-menu-item"
                key={m.title}
                onClick={() => m.onClick(m)}
              >
                <div className="flex items-center">
                  {m.icon}
                  {m.title}
                </div>
                <div>
                  <ChevronRight
                    className={"w-6 h-6 stroke-side-menu-item-chevron"}
                  />
                </div>
              </button>
            ))}

          {availableLanguages && availableLanguages.length > 1 && (
            <div className="mt-10 flex gap-4 justify-between">
              <select
                aria-label="Language switcher"
                className="flex-1 bg-input-select p-input-select border-input-select rounded-input-select"
                id="language"
                name="language"
                onChange={(e) => adjustLanguage(e.target.value)}
                value={selectedLanguage}
              >
                {availableLanguages?.map((l) => (
                  <option key={l.code} value={l.code}>
                    {l.description}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SideMenu;
